<template>
  <div>
    <div class="row">
      <div class="col-12" v-if="selectedStands.length">
        <stands-table :selected-stands="selectedStands" :show-values="true"
                      :cop-payment-currency="model.copPaymentCurrency"/>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <validation-provider v-slot="{ errors }" name="Forma de pago" rules="required">
          <v-select
            vid="paymentMethodId"
            v-model="model.paymentMethodId"
            :error-messages="errors"
            :items="paymentMethods"
            outlined
            dense
            item-text="name"
            item-value="id"
            label="Forma de pago"
          ></v-select>
        </validation-provider>
      </div>
      <div class="col-12 col-md-6">
        <validation-provider v-slot="{ errors }" name="Confirmación de forma de pago" rules="required">
          <v-select
            vid="confirmationPaymentMethodId"
            v-model="model.confirmationPaymentMethodId"
            :error-messages="errors"
            :items="paymentMethods"
            outlined
            dense
            item-text="name"
            item-value="id"
            label="Confirmación de forma de pago"
          ></v-select>
        </validation-provider>
      </div>
      <div class="col-12 col-md-6">
        <h3 v-if="model.paymentMethodId">Valor de las cuotas</h3>
        <v-simple-table v-if="model.paymentMethodId" dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Cuota #
              </th>
              <th class="text-left">
                Porcentaje
              </th>
              <th class="text-left">
                Valor
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(plan, index) in paymentPlans"
              :key="plan.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ plan.percentage * 100 }}%</td>
              <td>
                {{ model.copPaymentCurrency === 'COP' ? '$' : model.copPaymentCurrency === 'PEN' && peruFair ? 'S/' : model.copPaymentCurrency === 'BRL' && brasilFair ? 'R$' : '' }}
                {{ plan.percentage * totalPrice | currency }}
                {{ model.copPaymentCurrency === 'USD' ? 'USD' : '' }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>

      <div class="col-12 ml-2">
        <ValidationProvider v-slot="{ errors }" name="Términos y condiciones de uso de la información" rules="required">
          <v-checkbox v-model="model.termsAndConditions" :error-messages="errors"
                      :rules="[v => v || 'Debes aceptar los términos y condiciones de uso de la información para continuar']">
            <div slot='label'>
              <template v-if="brasilFair">
                Términos de uso de la información de los organizadores del evento:
                <a
                  v-if="habeasDataUrl3"
                  @click.stop
                  :href="habeasDataUrl3"
                  target="_blank"
                >{{ habeasDataUrl3Label }}</a>
              </template>
              <template v-else>
                Acepta los términos y condiciones de uso de la información de
                <a
                  v-if="habeasDataUrl1"
                  @click.stop
                  :href="habeasDataUrl1"
                  target="_blank"
                >{{ habeasDataUrl1Label }}</a> <span v-if="habeasDataUrl1">, </span>
                <a
                  v-if="habeasDataUrl2"
                  @click.stop
                  :href="habeasDataUrl2"
                  target="_blank"
                >{{ habeasDataUrl2Label }}</a> <span v-if="habeasDataUrl2"> y </span>
                <a
                  v-if="habeasDataUrl3"
                  @click.stop
                  :href="habeasDataUrl3"
                  target="_blank"
                >{{ habeasDataUrl3Label }}</a>.
              </template>
            </div>
          </v-checkbox>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import StandsTable from '@/views/public/booking/components/StandsTable'
import { PAYMENT_METHODS_URL } from '@/constants/ServicesConstants'
import crudServiceMixin from '@/mixins/crudServiceMixin'
import loaderMixin from '@/mixins/loaderMixin'
import notificationMixin from '@/mixins/notificationMixin'

export default {
  components: { StandsTable },
  async created () {
    try {
      this.showLoader()
      await this.getPaymentMethods()
      this.hideLoader()
    } catch {
      this.hideLoader()
      this.showError()
    }
  },
  computed: {
    totalPrice () {
      let totalPrice = 0
      this.selectedStands.forEach((stand) => {
        if (this.model.copPaymentCurrency === 'COP') {
          totalPrice += stand.copValue
        } else if (this.model.copPaymentCurrency === 'PEN' && this.peruFair) {
          totalPrice += stand.penValue
        } else if (this.model.copPaymentCurrency === 'BRL' && this.brasilFair) {
          totalPrice += stand.brlValue
        } else {
          totalPrice += stand.usdValue
        }
      })
      return totalPrice
    }
  },
  data () {
    return {
      habeasDataUrl1: process.env.VUE_APP_HABEAS_DATA_1,
      habeasDataUrl2: process.env.VUE_APP_HABEAS_DATA_2,
      habeasDataUrl3: process.env.VUE_APP_HABEAS_DATA_3,
      habeasDataUrl1Label: process.env.VUE_APP_HABEAS_DATA_LABEL_1,
      habeasDataUrl2Label: process.env.VUE_APP_HABEAS_DATA_LABEL_2,
      habeasDataUrl3Label: process.env.VUE_APP_HABEAS_DATA_LABEL_3,
      paymentMethods: [],
      paymentPlans: [],
      peruFair: process.env.VUE_APP_PERU_FAIR === '1',
      brasilFair: process.env.VUE_APP_BRASIL_FAIR === '1'
    }
  },
  methods: {
    async getPaymentMethods () {
      const response = await this.get(PAYMENT_METHODS_URL, { params: { fairId: this.fair.id } })
      this.paymentMethods = response.data
    }
  },
  mixins: [
    crudServiceMixin,
    loaderMixin,
    notificationMixin
  ],
  name: 'StandsConfirm',
  props: {
    fair: {
      default: null,
      type: Object
    },
    model: {
      default: null,
      type: Object
    },
    selectedStands: {
      default: () => [],
      type: Array
    }
  },
  watch: {
    'model.paymentMethodId': {
      handler (newValue) {
        const paymentMethod = this.paymentMethods.filter((item) => item.id === newValue)
        this.paymentPlans = paymentMethod[0].plans
      },
      deep: true
    }
  }
}
</script>
